'use strict';

exports.__esModule = true;
exports.reducer = reducer;

var _reactisDatagrid = require('reactis-datagrid');

var CLOSE = '@@Tab/Close';

function reducer(state, action) {
	switch (action.type) {
		case CLOSE:
			return state['delete'](action.id);

		default:
			return _reactisDatagrid.reducer(state, action);
	}
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/modules/datagridTab.js
 ** module id = 1033
 ** module chunks = 2
 **/